import { ComponentType } from 'react';
import { RolesEnum } from '../../externals/VerifyRole';
import { VideoEventsRoute } from '../components/VideoEventsRoute';
import VideoRecallRoute from '../components/VideoRecallRoute';
import { DeviceAssociation } from '$Pages/DeviceAssociation/DeviceAssociation';
import { Installers } from '$Pages/Installers/Installers';
import { Settings } from '$Pages/Settings/Settings';
import { VideoDashboardPage } from '$Pages/VideoDashboard/VideoDashboard';
import { InvalidRoute } from '$Pages/InvalidRoute/InvalidRoute';

export interface GeotabRouteConfig {
    path: string;
    label: string;
    Component: ComponentType;
    allowedRoles: RolesEnum[];
}

export enum GeotabRoutePaths {
    // VideoProtects paths
    VideoProtectsVideoEvents = 'addin-videoprotects-VideoEvents',
    VideoProtectsVideoRecall = 'addin-videoprotects-VideoRecall',
    VideoProtectsDeviceAssociations = 'addin-videoprotects-DeviceAssociations',
    VideoProtectsInstallers = 'addin-videoprotects-Installers',
    VideoProtectsSettings = 'addin-videoprotects-Settings',
    VideoProtectsVideoDashboard = 'addin-videoprotects-VideoDashboard',

    // VidLocate paths
    VidLocateVideoEvents = 'addin-vidlocate-VideoEvents',
    VidLocateVideoRecall = 'addin-vidlocate-VideoRecall',
    VidLocateDeviceAssociations = 'addin-vidlocate-DeviceAssociations',
    VidLocateInstallers = 'addin-vidlocate-Installers',
    VidLocateSettings = 'addin-vidlocate-Settings',
    VidLocateVideoDashboard = 'addin-vidlocate-VideoDashboard',

    CatchAll = '*',
}

export const geotabRouteConfig: GeotabRouteConfig[] = [
    // VideoProtects routes
    {
        path: GeotabRoutePaths.VideoProtectsVideoEvents,
        label: 'Video Events | MyGeotab',
        Component: VideoEventsRoute,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit],
    },
    {
        path: GeotabRoutePaths.VideoProtectsVideoRecall,
        label: 'Video Recall | MyGeotab',
        Component: VideoRecallRoute,
        allowedRoles: [RolesEnum.videoRecallEdit],
    },
    {
        path: GeotabRoutePaths.VideoProtectsDeviceAssociations,
        label: 'Device Association | MyGeotab',
        Component: DeviceAssociation,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VideoProtectsInstallers,
        label: 'Installers | MyGeotab',
        Component: Installers,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VideoProtectsSettings,
        label: 'Settings | MyGeotab',
        Component: Settings,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VideoProtectsVideoDashboard,
        label: 'Video Dashboard | MyGeotab',
        Component: VideoDashboardPage,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit],
    },

    // VidLocate routes
    {
        path: GeotabRoutePaths.VidLocateVideoEvents,
        label: 'Video Events | MyGeotab',
        Component: VideoEventsRoute,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit],
    },
    {
        path: GeotabRoutePaths.VidLocateVideoRecall,
        label: 'Video Recall | MyGeotab',
        Component: VideoRecallRoute,
        allowedRoles: [RolesEnum.videoRecallEdit],
    },
    {
        path: GeotabRoutePaths.VidLocateDeviceAssociations,
        label: 'Device Association | MyGeotab',
        Component: DeviceAssociation,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VidLocateInstallers,
        label: 'Installers | MyGeotab',
        Component: Installers,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VidLocateSettings,
        label: 'Settings | MyGeotab',
        Component: Settings,
        allowedRoles: [RolesEnum.videoAdmin],
    },
    {
        path: GeotabRoutePaths.VidLocateVideoDashboard,
        label: 'Video Dashboard | MyGeotab',
        Component: VideoDashboardPage,
        allowedRoles: [RolesEnum.videoEventView, RolesEnum.videoEventEdit],
    },

    // Catch all
    {
        path: GeotabRoutePaths.CatchAll,
        label: 'Invalid Route | MyGeotab',
        Component: InvalidRoute,
        allowedRoles: [],
    },
];

export const findGeotabRoute = (rawHash: string): GeotabRouteConfig => {
    const hash = (rawHash || '').replace(/^#/, '');
    // Strip everything after first comma for base
    const base = hash.split(',')[0];
    const match = geotabRouteConfig.find((r) => r.path !== GeotabRoutePaths.CatchAll && base === r.path);
    return match || geotabRouteConfig.find((r) => r.path === GeotabRoutePaths.CatchAll)!;
};
